import iMISFetch from "@/utils/iMISFetch";
import { IQA_PURCHASED, QUERY_ENDPOINT } from "@/store/constants";
import type { PurchasedRow } from "@/store/types";

/**
 * GET /api/query?queryname=$/ASI/Store/Purchased&Id={partyId}
 *
 * Returns products the given party has purchased (via coupon or full price)
 * that are still available in the store. Unlike CouponsAvailable/CouponsUsed,
 * this IQA does not self-scope to the request party, so the party ID is
 * passed explicitly as an `Id` param (iMISFetch splits the query string on
 * the first `&` into extra URL params — see iMISFetch.ts). Returns [] on a
 * successful-but-empty response; throws on network/5xx.
 */
export async function fetchPurchasedProducts(partyId: string): Promise<PurchasedRow[]> {
  const result = await iMISFetch<PurchasedRow>(QUERY_ENDPOINT, {
    query: `${IQA_PURCHASED}&Id=${partyId}`,
    limit: 0,
  });
  if (!result.success) {
    throw new Error(`fetchPurchasedProducts failed: ${result.message || "unknown error"}`);
  }
  return Array.isArray(result.data) ? (result.data as PurchasedRow[]) : [];
}
